export const THONGTINHOSO_SET_LIST_DATA = 'THONGTINHOSO_SET_LIST_DATA';
export const THONGTINHOSO_SET_LIST_META = 'THONGTINHOSO_SET_LIST_META';
export const THONGTINHOSO_TITLE = 'Thông tin hồ sơ';